const DICTIONARY_WORDS_INITIAL_STATE = {
  isLoading: false,
  error: undefined,
  data: {},
}

export default DICTIONARY_WORDS_INITIAL_STATE
